import { useCallback, useContext } from "react";
import classNames from "classnames";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { shopTypeTranslation } from "src/translations/shopTypeTranslation";
import { useLingui } from "@lingui/react";
import {
  useShopTypeContext,
  useShopTypeDispatch,
} from "src/hooks/context/use-shop-type-context";
import { locale } from "src/config/app-config";
import { getI18nRoute } from "src/utils/i18nRoutes";
import { OT_SHOP_TYPE_COOKIE } from "src/utils/constants";
import { SearchResultsDispatchContext } from "../search-results.context";

function ShopTypeButton({ shopTypeId }: { shopTypeId: string }) {
  const { _ } = useLingui();
  const router = useRouter();
  const { currentShopType } = useShopTypeContext();
  const dispatchShopType = useShopTypeDispatch();
  const { onShopTypeNavigate } = useContext(SearchResultsDispatchContext);

  const handleClick = useCallback(() => {
    onShopTypeNavigate();
    Cookies.set(OT_SHOP_TYPE_COOKIE, shopTypeId);
    dispatchShopType({ type: "SET_SHOP_TYPE", payload: shopTypeId });
    void router.push(getI18nRoute({ route: `/${shopTypeId}`, locale }));
  }, [onShopTypeNavigate, shopTypeId, dispatchShopType, router]);

  return (
    <button
      aria-label={_(shopTypeTranslation[shopTypeId])}
      className={classNames("shop-type-button", {
        ["selected"]: currentShopType === shopTypeId,
      })}
      onClick={handleClick}
    >
      {_(shopTypeTranslation[shopTypeId] || "")}
    </button>
  );
}

export { ShopTypeButton };
